import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/primeng';

// import { InventoryBalanceReportViewerComponent } from '../inventory-balance-report-viewer/inventory-balance-report-viewer.component';
import { DataService } from 'app/infrastructure/services/base/config/data.service';

import { BaseComponent, Constant, DatePickerFormatter } from 'app/infrastructure/common';
import { ReportFormatService } from 'app/infrastructure/services/base/index';
import { InventoryStatusService, OnlineOrderService, OnlineOrderReportService } from 'app/infrastructure/services/transaction/op/outbound/order/index';
import { WarehouseAuthService } from 'app/infrastructure/services/master/wm/config';

declare var jQuery: any;

// import  '../../common/date-formatted';
// import { toFormatDatePicker } from '../../../common/date-formatted-func';

import * as _ from 'lodash';
import * as moment from 'moment';

declare var jQuery: any;
@Component({
    selector: 'inventory-balance-lwin-report',
    templateUrl: './inventory-balance-lwin-report.html',
    providers: [DataService],
    styles: [`
        .input-group{
            border-spacing: 0; border-collapse: separate;
        }
        .input-group-addon{
            padding: 0 12px !important;
        }
    `]

})
export class InventoryBalanceLWINReportComponent extends BaseComponent implements OnInit {

    isLoading: boolean = false;
    isLoadingReportFormats: boolean = false;
    isLoadingAccounts: boolean = false;
    isLoadingWarehouses: boolean = false;
    isLoadingInventoryStatuses: boolean = false;

    accounts: any[];
    warehouses: any[];
    inventoryStatuses: any[];

    searchParams: any = {};
    display: boolean = false;

    // dateParams: any = {};
    // asAtDate: string;
    // fromExpiryDate: string;
    // toExpiryDate: string;

    arrCboAccounts: any[] = [];
    arrCboOrderTypes: any[] = ['Repeat Order', 'Release Order'];
    // arrCboFormat: any[] = ['PDF'];
    // arrCboFormat: any[] = ['PDF', 'XLS', 'CSV'];
    reportFormats: any[] = [];

    // constructor(private dtService: DataService,
    constructor(private inventoryStatusService: InventoryStatusService,
        private onlineOrderService: OnlineOrderService,
        private onlineOrderReportService: OnlineOrderReportService,
        private reportFormatService: ReportFormatService,
        private warehouseAuthService: WarehouseAuthService) {
        super();
    }

    ngOnInit(): void {
        this.searchParams.ReportFormat = Constant.defaultReportFormat;
        // this.asAtDate = moment().format(this.token.DateFormatDescription);

        this.loadReportFormats();
        this.loadAccounts();
        this.loadWarehouses();
        this.loadInventoryStatuses();
        // this.getAccounts();
    }

    loadReportFormats(): void {
        let self = this;
        this.isLoadingReportFormats = true;

        this.reportFormatService.getReportFormats()
            .subscribe(
            data => {
                self.isLoadingReportFormats = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.reportFormats = message.Result;
                        this.searchParams['ReportFormat'] = 'XLSR';
                    }
                    else {
                        self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingReportFormats = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadAccounts(): void {
        let self = this;
        this.isLoadingAccounts = true;

        var groupId = this.token.GroupId;
        this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
            .subscribe(
            data => {
                self.isLoadingAccounts = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.accounts = message.Result;
                        self.searchParams.OwnerCode = self.token.DefaultOwnerCode;
                    }
                    else {
                        self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingAccounts = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadWarehouses(): void {
        let self = this;
        this.isLoadingWarehouses = true;

        var groupId = this.token.GroupId;
        this.warehouseAuthService.getWarehouseAuthsWithName(groupId)
            .subscribe(
            data => {
                self.isLoadingWarehouses = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.warehouses = message.Result;
                        self.searchParams.FromWarehouseCode = self.token.DefaultWarehouseCode;
                        self.searchParams.ToWarehouseCode = self.token.DefaultWarehouseCode;
                    }
                    else {
                        self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingWarehouses = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadInventoryStatuses(): void {
        let self = this;
        this.isLoadingInventoryStatuses = true;

        this.inventoryStatusService.getInventoryStatusesWithDescription()
            .subscribe(
            data => {
                self.isLoadingInventoryStatuses = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.inventoryStatuses = message.Result;
                    }
                    else {
                        self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingInventoryStatuses = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    // getAccounts(): void {
    //     this.dtService.getJSON("../../../assets/mock-data/account.json")
    //         .subscribe(
    //         data => this.arrCboAccounts = data.Account,
    //         error => console.log(error),
    //         // () => console.log("Finished Call Accounts")
    //     );
    // }
    ngAfterViewInit() {
        let self = this;

        // var format=toFormatDatePicker("dd/mm/yyyy");
        // jQuery('.mydatepicker').datepicker({
        //     autoclose: true,
        //     clearBtn: true,
        //     format: format
        // }).on('change', (e) => {
        //     // if(e.target.value!=""){
        //     //     var d = new Date(e.target.value);
        //     //     e.target.value=d.format('dd-MM-yyyy');
        //     // }
        //     //this.search[e.target.name] = e.target.value;
        // });

        jQuery('.mydatepicker').datepicker({
            autoclose: true,
            clearBtn: true,
            format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription)
        }).on('change', (e) => {
            // alert(self[e.target.name]);
            //let date = jQuery(e.target).datepicker('getDate');
            self.searchParams[e.target.name] = e.target.value;
        });

    }

    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }

    preview() {
        let self = this;
        // alert(this.searchParams.IsContainerVisible);
        // this.display = true;
        this.searchParams.SessionId = this.token.SessionId;
        this.searchParams.ReportName = 'LWIN Inventory Balance Report';
        // this.searchParams.OwnerCode = 'CHR';
        // this.searchParams.FromWarehouseCode = 'MLL';
        // this.searchParams.ToWarehouseCode = 'MLL';
        // this.searchParams.AsAtDate = new Date();
        // this.searchParams.IsPalletVisible = false;
        // this.searchParams.IsContainerVisible = false;
        // let asAtDate = moment(this.dateParams.AsAtDate, this.token.DateTimeFormatDescription);
        // let fromExpiryDate = moment(this.dateParams.FromExpiryDate, this.token.DateTimeFormatDescription);
        // let toExpiryDate = moment(this.dateParams.ToExpiryDate, this.token.DateTimeFormatDescription);

        // this.searchParams.AsAtDate = this.dateParams.AsAtDate && moment(this.dateParams.AsAtDate, this.token.DateTimeFormatDescription);
        // this.searchParams.FromExpiryDate = this.dateParams.FromExpiryDate && moment(this.dateParams.FromExpiryDate, this.token.DateTimeFormatDescription);
        // this.searchParams.ToExpiryDate = this.dateParams.ToExpiryDate && moment(this.dateParams.ToExpiryDate, this.token.DateTimeFormatDescription);
        this.searchParams.DateFormat = this.token.DateFormatDescription;
        // this.searchParams.ReportFormat = 'PDF'
        this.searchParams.ToWarehouseCode = this.searchParams.FromWarehouseCode;
        this.isLoading = true;
        debugger
        this.onlineOrderReportService.exportInventoryBalanceLWINExcel(this.searchParams).subscribe(
            (data) => {
                self.isLoading = false;
                var fileURL = URL.createObjectURL(data);
                window.open(fileURL);
            },
            error => {
                // alert(JSON.stringify(error));
                // alert(error);
                self.isLoading = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
        );
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''))
    }

truncateString(str, num) {
      if(str!=null){
        return str.length > num ? str.slice(0, num) + '...' : str;
      } else {
        return ''
      }
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
      let truncatedAdditionalInfo = this.truncateString(additionalInfo, 1000);
      jQuery('#PopupMessageTitle').html(title);
      jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (truncatedAdditionalInfo ? ' -- ' + truncatedAdditionalInfo : ''));
      jQuery('#PopupMessage').modal('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/reports/inventory-balance-lwin-report/inventory-balance-lwin-report.component.ts